import styled from "styled-components";

export type TextConfig = React.HTMLAttributes<HTMLParagraphElement>;

export const Text = styled.p<TextConfig>`
  font-family: var(--typography-text-font-family);
  font-weight: var(--typography-text-font-weight);
  font-size: var(--typography-text-font-size-desktop);
  line-height: var(--typography-text-line-height);
  letter-spacing: var(--typography-text-letter-spacing);

  @media (max-width: 768px) {
    font-size: var(--typography-text-font-size-mobile);
  }

  margin: 0;
  word-wrap: break-word;
  overflow-wrap: anywhere;
`;
